import { KeyboardEvent, useCallback } from 'react';

import { StepProps } from '../../components';

type Props = Pick<StepProps, 'trigger' | 'clearErrors' | 'name' | 'onNext'>;

const useOnNextStep = (props: Props) => {
  const onClick = useCallback(async () => {
    const isValid = await props.trigger(props.name);
    if (isValid) {
      props.clearErrors();
      props.onNext();
    }
  }, [props]);

  const onKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onClick();
      }
    },
    [onClick],
  );

  return { onClick, onKeyDown };
};

export default useOnNextStep;
